/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Yup from "yup";

import {
  BoatType,
  typeWithMotorOrSail,
} from "Store/interfaces/products/checkout/riskProducts/BoatProduct";

import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { TextManager } from "Components/TextContext";
import { Validation } from "Components/TextContext/commonComponentEnums";
import { ErrorPrefix } from "Constants/constants";
import { zipCodeRegex } from "Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { BoatProductDetailsFormValues } from "./boatProductDetailsInterfaces";

export const validationSchema = (
  boatType: BoatType,
): Yup.ObjectSchema<BoatProductDetailsFormValues> => {
  const { getText } = TextManager;

  return Yup.object().shape({
    postNumber: Yup.string().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema
          .required(getText(Validation.POSTNUMBER_REQUIRED))
          .matches(zipCodeRegex, getText(Validation.POSTNUMBER_INVALID))
          .test(
            "postnumber is valid",
            getText(Validation.POSTNUMBER_INVALID),
            function () {
              return this.parent.validPostNumber;
            },
          ),
    }),

    city: Yup.string(),

    validPostNumber: Yup.boolean(),

    trackingSystem: Yup.mixed<BooleanFormType>().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema.required(getText("boatform.validation.trackingsystem")),
    }),

    hullAndEngineIdMarked: Yup.mixed<BooleanFormType>().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema.required(getText("boatform.validation.hullandengineidmarked")),
    }),

    memberOfRedningsselskapetCoastGuard: Yup.mixed<BooleanFormType>().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema.required(
          getText("boatform.validation.memberofredningsselskapetcoastguard"),
        ),
    }),

    usedByYoungerDriver: Yup.mixed<BooleanFormType>().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema.required(getText("boatform.validation.usedbyyoungerdriver")),
    }),

    harbourSecurity: Yup.mixed<BooleanFormType>().when({
      is: () => typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema.required(getText("boatform.validation.harboursecurity")),
    }),
    injuries: Yup.mixed<DamageRecentYears>().when({
      is: () => !typeWithMotorOrSail(boatType),
      then: (schema) =>
        schema
          .required(getText("recentdamages.validation.injuries-required"))
          .notOneOf(
            [DamageRecentYears.TWO_OR_MORE],
            ErrorPrefix.BREAKING +
              getText("recentdamages.validation.injuries-maxdamages"),
          ),
    }),
    injuryYear: Yup.string().when("injuries", {
      is: (value: DamageRecentYears) => value === DamageRecentYears.ONE,
      then: (schema) =>
        schema.required(getText("recentdamages.validation.injuryyear")),
    }),
  });
};
